// FILE: src/blueprint/state/applyInitialRunState.js

import { ACTIONS } from './blueprintReducer.js';

function asObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function makeAnswerKey(packId, moduleId, trackId, stepId) {
  const p = String(packId || '').trim();
  const m = String(moduleId || '').trim();
  const t = String(trackId || '').trim();
  const s = String(stepId || '').trim();

  if (!p || !m || !t || !s) {
    return s;
  }

  return `${p}::${m}::${t}::${s}`;
}

export default function applyInitialRunState({
  initialState,
  dispatch,
  packId,
  moduleId,
  trackId,
  activeModuleDoc,
}) {
  const root = asObject(initialState);
  const run = asObject(root.run);
  const responses = asObject(root.responses);

  const scopedAnswers = {};

  Object.entries(responses).forEach(([stepId, value]) => {
    const cleanStepId = String(stepId || '').trim();

    if (!cleanStepId) {
      return;
    }

    const answerKey = makeAnswerKey(packId, moduleId, trackId, cleanStepId);
    scopedAnswers[answerKey] = value;
  });

  dispatch({
    type: ACTIONS.SET_ANSWERS,
    payload: { answers: scopedAnswers },
  });

  const hasSteps = Array.isArray(activeModuleDoc?.steps) && activeModuleDoc.steps.length > 0;
  const currentStepId = String(run.current_step_id ?? '').trim();

  if (hasSteps && currentStepId) {
    dispatch({
      type: ACTIONS.SET_CURRENT_STEP_ID,
      payload: { currentStepId },
    });
  }
}
